import { useState } from 'react';
import { useMsal } from '@azure/msal-react';
import { loginRequest as msalLoginRequest } from '../../lib/msalConfig';
import { getErrorMessage } from '../../lib/api';

const MS_ICON = (
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 21 21">
    <rect x="1" y="1" width="9" height="9" fill="#f25022" />
    <rect x="11" y="1" width="9" height="9" fill="#7fba00" />
    <rect x="1" y="11" width="9" height="9" fill="#00a4ef" />
    <rect x="11" y="11" width="9" height="9" fill="#ffb900" />
  </svg>
);

export default function LoginScreen({ onSubmit, onMicrosoftLogin, loading }) {
  const { instance } = useMsal();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError('');

    if (!username.trim() || !password.trim()) {
      setError('กรุณากรอก username และ password');
      return;
    }

    try {
      await onSubmit({
        username: username.trim(),
        password,
      });
      setPassword('');
    } catch (submitError) {
      setError(getErrorMessage(submitError, 'เข้าสู่ระบบไม่สำเร็จ'));
    }
  };

  const handleMicrosoftLogin = async () => {
    setError('');
    try {
      // Use useMsal instance.loginPopup — same as hr-frontend
      const msResult = await instance.loginPopup({
        ...msalLoginRequest,
        prompt: 'select_account',
      });

      if (msResult?.account) {
        instance.setActiveAccount(msResult.account);
      }

      // Exchange Microsoft idToken with our backend
      await onMicrosoftLogin(msResult.idToken);
    } catch (msError) {
      if (msError.errorCode === 'user_cancelled') return;
      console.error('Microsoft login error:', msError);
      setError(getErrorMessage(msError, 'เข้าสู่ระบบด้วย Microsoft ไม่สำเร็จ'));
    }
  };

  return (
    <div style={{ minHeight: '100vh', display: 'grid', placeItems: 'center', padding: '24px', background: 'linear-gradient(160deg, #0d1117 0%, #111827 38%, #f7f8fa 38%, #f7f8fa 100%)' }}>
      <div className="form-card" style={{ width: '100%', maxWidth: '460px', padding: '28px 30px' }}>
        <div style={{ marginBottom: '18px' }}>
          <div className="logo-badge" style={{ color: 'var(--ink)', marginBottom: '10px' }}>
            <div className="logo-dot"></div>
            BSR · SYSREG
          </div>
          <div style={{ fontSize: '24px', fontWeight: 800, color: 'var(--ink)', lineHeight: 1.2 }}>
            เข้าสู่ระบบ
          </div>
          <div style={{ fontSize: '13px', color: 'var(--text2)', marginTop: '8px' }}>
            ใช้บัญชี Active Directory เดียวกับระบบ HR
          </div>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="form-group" style={{ marginBottom: '14px' }}>
            <label>Username</label>
            <input
              className="form-input"
              autoComplete="username"
              value={username}
              onChange={(event) => setUsername(event.target.value)}
              placeholder="เช่น john.doe"
            />
          </div>

          <div className="form-group" style={{ marginBottom: '14px' }}>
            <label>Password</label>
            <div style={{ position: 'relative' }}>
              <input
                className="form-input"
                type={showPassword ? 'text' : 'password'}
                autoComplete="current-password"
                value={password}
                onChange={(event) => setPassword(event.target.value)}
                placeholder="กรอกรหัสผ่าน"
                style={{ paddingRight: '52px' }}
              />
              <button
                type="button"
                onClick={() => setShowPassword((prev) => !prev)}
                style={{
                  position: 'absolute', right: '8px', top: '50%', transform: 'translateY(-50%)',
                  background: 'none', border: 'none', cursor: 'pointer', fontSize: '13px',
                  color: 'var(--text2)', padding: '4px',
                }}
              >
                {showPassword ? 'ซ่อน' : 'แสดง'}
              </button>
            </div>
          </div>

          {error && (
            <div className="alert alert-danger" style={{ marginBottom: '14px' }}>
              {error}
            </div>
          )}

          <button className="btn btn-primary" type="submit" disabled={loading} style={{ width: '100%', justifyContent: 'center' }}>
            {loading ? 'กำลังเข้าสู่ระบบ...' : 'เข้าสู่ระบบ'}
          </button>
        </form>

        <div style={{ display: 'flex', alignItems: 'center', gap: '12px', margin: '16px 0' }}>
          <div style={{ flex: 1, height: '1px', background: 'var(--border)' }} />
          <span style={{ fontSize: '12px', color: 'var(--text2)' }}>หรือ</span>
          <div style={{ flex: 1, height: '1px', background: 'var(--border)' }} />
        </div>

        <button
          type="button"
          className="btn btn-ghost"
          onClick={handleMicrosoftLogin}
          disabled={loading}
          style={{
            width: '100%', justifyContent: 'center',
            display: 'flex', alignItems: 'center', gap: '8px',
          }}
        >
          {MS_ICON}
          เข้าสู่ระบบด้วย Microsoft
        </button>
      </div>
    </div>
  );
}
